<script>
import { mapActions } from "vuex";
import NumberReveal from "../common/numberReveal.vue";

export default {
  name: "meetAgent",
  components: {NumberReveal},
  data() {
    return {
      loading: false,
      showAgent1FullText: false,
      showAgent2FullText: false,
      rules: {
        name: {
          required: true,
          message: "Please enter your name",
          trigger: "blur"
        },
        email: {
          required: true,
          message: "Please enter a correct email",
          trigger: "blur",
          pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,20}$/
        },
        phoneNumber: {
          required: true,
          message: "Please enter phone number",
          trigger: "blur"
        },
        message: {
          required: true,
          message: "Please enter message",
          trigger: "blur"
        }
      },
      form: {
        name: "",
        email: "",
        phoneNumber: "",
        message: ""
      }
    };
  },
  props: {
    propsData: Object
  },
  methods: {
    ...mapActions("contact", ["contact"]),
    readMoreToggle() {
      this.showAgent1FullText = !this.showAgent1FullText;
      this.showAgent2FullText = !this.showAgent2FullText;
    },
    getMobileNumber(countryCode, mobileNumber) {
      return countryCode + " " + mobileNumber;
    },
  }
};
</script>

<template>
  <el-row style="padding: 10px 5px; background-color: #003333">
    <el-col :span="24">
      <el-row>
        <el-col :span="24" style="display: flex; justify-content: center">
          <el-avatar
            :fit="'contain'"
            :size="130"
            :src="propsData.agentImageUrl1"
          ></el-avatar>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24" style="display: flex; justify-content: center">
          <span class="agent-name">{{ propsData.agentFirstName1 }}</span>
        </el-col>
        <el-col :span="24" style="display: flex; justify-content: center">
          <span class="agent-name">{{ propsData.agentLastName1 }}</span>
        </el-col>
        <el-col
          v-if="propsData.agentMobile1"
          :span="24"
          style="display: flex; justify-content: center"
        >
          <number-reveal :phone-number="getMobileNumber(propsData.agentCountryCode1, propsData.agentMobile1)" />
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24" style="display: flex; justify-content: flex-start">
          <span class="meet-agent-title">Meet your agent</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24" class="agent-desc" style="margin-top: 1%;">
          <span class="agent-desc-wrap" :class="{'limited-lines': !showAgent1FullText}">{{ propsData.agentImageBio1 }}</span>
        </el-col>
        <el-col :span="24" style="display: flex; justify-content: center">
          <el-link class="link-style" @click="readMoreToggle">{{ showAgent1FullText ? 'Read Less' : 'Read More' }}</el-link>
        </el-col>
        <el-col :span="24" class="agent-desc" style="margin-top: 1%;">
          <span class="agent-desc-wrap">{{ propsData.companyRla }}</span>
        </el-col>
      </el-row>
    </el-col>

    <el-col
      v-if="propsData.agentFirstName2"
      :span="24"
      style="margin-top: 10px"
    >
      <el-row>
        <el-col :span="24" style="display: flex; justify-content: center">
          <el-avatar
            :fit="'contain'"
            :size="130"
            :src="propsData.agentImageUrl2"
          ></el-avatar>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24" style="display: flex; justify-content: center">
          <span class="agent-name">{{ propsData.agentFirstName2 }}</span>
        </el-col>
        <el-col :span="24" style="display: flex; justify-content: center">
          <span class="agent-name">{{ propsData.agentLastName2 }}</span>
        </el-col>
        <el-col
          v-if="propsData.agentMobile2"
          :span="24"
          style="display: flex; justify-content: center"
        >
          <number-reveal :phone-number="getMobileNumber(propsData.agentCountryCode2, propsData.agentMobile2)" />
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24" style="display: flex; justify-content: flex-start">
          <span class="meet-agent-title">Meet your agent</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 10px">
        <el-col :span="24" class="agent-desc" style="margin-top: 1%;">
          <span class="agent-desc-wrap" :class="{'limited-lines': !showAgent2FullText}">{{ propsData.agentImageBio2 }}</span>
        </el-col>
        <el-col :span="24" style="display: flex; justify-content: center">
          <el-link class="link-style" @click="readMoreToggle">{{ showAgent2FullText ? 'Read Less' : 'Read More' }}</el-link>
        </el-col>
        <el-col :span="24" class="agent-desc" style="margin-top: 1%;">
          <span class="agent-desc-wrap">{{ propsData.companyRla }}</span>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<style scoped>
.meet-agent-title {
  color: #ffffff;
  font-family: DINosaur-a, sans-serif;
  font-size: 34px;
  font-style: normal;
  font-weight: 600;
  line-height: 117.647%;
  align-self: stretch;
}

.agent-name {
  font: 400 20px/26px DINosaur-a, sans-serif;
  color: #ffffff;
}

.agent-desc {
  font: 400 18px/24px DINosaur-a, sans-serif;
  color: #f5f5f5;
}

.agent-desc-wrap {
  white-space: pre-wrap;
  transition: max-height 0.5s ease, padding 0.5s ease;
  overflow: hidden;
}
.agent-desc-wrap.limited-lines {
  display: -webkit-box;
  -webkit-line-clamp: 8;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: calc(1.2em * 8);
  line-height: 1.2em;
}
.link-style {
  font-size: 18px;
  padding: 10px 0;
  color: #ffffff;
  font-style: italic;
  border-bottom: 1px solid #ffffff;
  transition: font-size 0.3s;
}

.link-style:hover {
  color: #ffffff;
  border-bottom: 1px solid #2491ff;
  font-size: 19px;
}
</style>



// WEBPACK FOOTER //
// src/components/propertyDetails/meetAgent.vue